import React from 'react';

const Paginacion = ({
  paginaActual,
  totalPaginas,
  cambiarPagina,
  indiceInicio,
  indiceFin,
  totalElementos,
  tipoElemento = 'productos'
}) => {
  if (totalElementos <= 20) return null; // No mostrar paginación si hay 20 o menos elementos

  return (
    <div className="paginacion-container mt-4">
      <nav aria-label={`Paginación de ${tipoElemento}`}>
        <ul className="pagination justify-content-center">
          <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
            <button 
              className="page-link" 
              onClick={() => cambiarPagina(paginaActual - 1)}
              disabled={paginaActual === 1}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
          </li>
          
          {/* Mostrar páginas */}
          {Array.from({ length: totalPaginas }, (_, i) => i + 1).map(numeroPagina => {
            // Mostrar solo algunas páginas alrededor de la actual
            const mostrarPagina = 
              numeroPagina === 1 || 
              numeroPagina === totalPaginas || 
              (numeroPagina >= paginaActual - 2 && numeroPagina <= paginaActual + 2);
            
            if (!mostrarPagina) {
              if (numeroPagina === paginaActual - 3 || numeroPagina === paginaActual + 3) {
                return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
              }
              return null;
            }
            
            return (
              <li key={numeroPagina} className={`page-item ${paginaActual === numeroPagina ? 'active' : ''}`}>
                <button 
                  className="page-link" 
                  onClick={() => cambiarPagina(numeroPagina)}
                >
                  {numeroPagina}
                </button>
              </li>
            );
          })}
          
          <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
            <button 
              className="page-link" 
              onClick={() => cambiarPagina(paginaActual + 1)}
              disabled={paginaActual === totalPaginas}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </li>
        </ul>
      </nav>
      
      <div className="text-center text-muted small">
        Mostrando {indiceInicio + 1} - {Math.min(indiceFin, totalElementos)} de {totalElementos} {tipoElemento}
      </div>
    </div>
  );
};

export default Paginacion;
